import { LOG_IN, LOG_OUT } from '../actions/actionTypes';

const initialState = {
  isLoggedIn: false,
  user: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LOG_IN: {
      const { isLoggedIn, user } = action.payload;
      return {
        isLoggedIn: isLoggedIn,
        user: user,
      };
    }

    case LOG_OUT: {
      const { isLoggedIn } = action.payload;
      return {
        isLoggedIn: isLoggedIn,
        user: null,
      };
    }

    default:
      return state;
  }
}
